const Hello = () => {
  return (
    <div className="py-[80px] dark:bg-gray-900">
      <div className="container-block">
        <div className="flex justify-center">
          <div className="w-full md:w-6/12">
            <h1 className="heading">What's next</h1>
            <h1 className="text-4xl font-bold text-teal-900 capitalize mt-4 dark:text-teal-400">
              get in touch
            </h1>
            <p className="mt-4 text-[15px] font-medium leading-[26px] dark:text-white">
              Although I’m currently looking for any new opportunities, my inbox
              is always open. Whether you have a question or just want to say
              hi, I’ll try my best to get back to you!
            </p>
            <div className="mt-4">
              <a
                href="mailto:shakilkhan621@gmail.com"
                className="btn btn-default"
              >
                say hello
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hello;
